import Vue from "vue";
import Component from "vue-class-component";

import { StaffScheduleStore } from "@/store/modules/Staff/Schedule";
import { WorkersStore } from "@/store/modules/Workers";
import { WorkersMix } from "@/UI/mixins/Store/WorkersMix";

import { CalendarWorkerItem } from "@/entity/Calendar/calendar.types"; // import locale
import { mixins } from "vue-class-component";
import { IWorkers, IWorkersListItem } from "@/entity/workers/workers.types";
import { DateMix } from "@/UI/mixins/Calendar/DateMix";
import { IStaffScheduleListItem } from "@/entity/staff/schedule.types";

@Component
export class StaffSheduleMix extends mixins(WorkersMix, DateMix) {
    WorkersData: Array<CalendarWorkerItem> = [];

    /*async sheduleItems(id:number):any => {
    }
*/
    get WorkersDta():IWorkersListItem[] {
        const data:IWorkersListItem[] = []
        this.workers?.data.map((worker:IWorkersListItem)=>{
            // Активный или Стажер
            if (worker['status']['id'] === 1 || worker['status']['id'] === 3) {
                data.push(worker)
            }
        })
        return  data
    }

    async getShedule(id: number): Promise<void> {
        await StaffScheduleStore.fetchAll({ filter: { id: id } });
    }

    get shedules(): IStaffScheduleListItem[] {
        return StaffScheduleStore.items;
    }

    parseShedule = (worker: IWorkersListItem,shedule: IStaffScheduleListItem[] | null) => {
        if (shedule){
            this.WorkersData.push({ worker: worker, schedule: StaffScheduleStore.items})
        }
        return Promise.resolve("ok");
    };

    doSomethingAsync = async (worker: IWorkersListItem) => {
        const dta = this.getCalendarDate().formatted;

        try {
            await StaffScheduleStore.fetchAll({
                filter: {
                    id: worker["id"],
                    day: dta.day,
                    month: dta.month + 1,
                    year: dta.year,
                },
            })
        } catch (e) {
            console.log('StaffScheduleStore Error -'+e)
        }

        return this.parseShedule(worker, this.shedules);
    };
    getDataShedule = async (workers: IWorkers) => {
        return Promise.all(workers.data.map((item: IWorkersListItem) => this.doSomethingAsync(item)));
    };

    async getWorkersWithShedulle(studioId: number): Promise<void> {
        await WorkersStore.fetchAll({ filter: { salon_id: studioId } });

        //async.map(this.workers?.data?)

        /*
          var results: number[] = await Promise.map(arr, async (item): Promise<number> => {
    await callAsynchronousOperation(item);
    return item + 1;
  });
         */

        /*this.workers?.data?.reduce(async (worker: IWorkersListItem) => {
            const dta = this.getCalendarDate().formatted;
            StaffScheduleStore.fetchAll({
                filter: {
                    id: worker["id"],
                    day: dta.day,
                    month: dta.month + 1,
                    year: dta.year,
                },
            }).then(() => {
                this.WorkersData.push({ worker: worker, schedule: StaffScheduleStore.items});
            })
        });*/
    }

    async getSheduleWithDate(id: number, day: number, month: number, year: number): Promise<void> {
        await StaffScheduleStore.fetchAll({
            filter: {
                id: id,
                day: day,
                month: month,
                year: year,
            },
        });
    }
}

///api/staff/schedule/get?filter[staff_id]=6
